// uuid key
export const UUID_KEY = 'User-UUID'
// token key
export const USER_TOKEN_KEY = 'or_token'
// refresh key
export const USER_REFRESH_TOKEN_KEY = 'or_refresh_token'
// user info
export const USER_INFO_KEY = 'or_user_info'